﻿import React, {Component} from "react";
import {connect} from "react-redux";
import {AgGridReact} from "ag-grid-react";
import service from "../../services/chat-archive-services";
import authService from "../../services/auth-services";

class ChatArchiveList extends Component {
    constructor(props, context) {
        super(props, context);

        this.handleResize = this.handleResize.bind(this);

        let tableHeight = this.getTableHeight();
        this.state = {
            tableHeight
        };

        this.refreshTimeout = null;
        this.selectedChat = null;
        this.gridOptions = null;
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    componentWillUnmount() {
        this.props.onUnload();
        window.removeEventListener('resize', this.handleResize);
    }

    shouldComponentUpdate(nextProps, nextState) {

        if (this.gridOptions && this.selectedChat !== nextProps.selectedChat) {
            this.selectedChat = nextProps.selectedChat;

            if (this.refreshTimeout) {
                clearTimeout(this.refreshTimeout);
            }

            this.refreshTimeout = setTimeout(() => {
                this.gridOptions.api.onFilterChanged();
            }, 500);

        }
        return !this.gridOptions;
    }

    getTableHeight() {
        return window.innerHeight - 64/*header*/ - 20;
    }

    handleResize(e) {
        setTimeout(() => {
            let tableHeight = this.getTableHeight();
            this.setState({tableHeight: tableHeight});

            if (this.gridOptions) {
                this.gridOptions.api.sizeColumnsToFit();
            }

        }, 200);
    }

    onGridReady(options) {
        let self = this;
        console.log(options);
        this.gridOptions = options;

        let defaultFilter = {
            Active: {type: 'equals', filter: 1}
        };

        this.gridOptions.api.setFilterModel(defaultFilter);

        let dataSource = {
            rowCount: null, // behave as infinite scroll
            getRows: function (params) {
                console.log(params);
                // At this point in your code, you would call the server, using $http if in AngularJS 1.x.
                // To make the demo look real, wait for 500ms before returning

                let filterModel = [];
                for (let key in params.filterModel) {
                    if (params.filterModel.hasOwnProperty(key)) {
                        let filterObject = params.filterModel[key];
                        let newObject = {
                            colId: key,
                            filter: filterObject.filter,
                            filterType: filterObject.filterType,
                            type: filterObject.type
                        };
                        filterModel.push(newObject);
                    }
                }

                let serverParams = {
                    endRow: params.endRow,
                    startRow: params.startRow,
                    room: self.selectedChat,
                    sortModel: params.sortModel,
                    filterModel: filterModel
                };

                service.ChatArchiveServices.getChatArchives(JSON.stringify(serverParams))
                    .then(response => {
                            if (response.json && response.status !== 200) {
                                throw response;
                            }

                            response.json().then(data => {
                                params.successCallback(data.Data, data.Total);
                            });
                        }
                    ).catch(error => {
                    console.error(error);

                    if (error.json) {
                        error.json().then(body => {
                            if (error.status === 401) {
                                self.props.onLogout()
                            } else {
                                self.props.onError(body);
                            }
                        });
                    }
                    else {
                        self.props.onError(error);
                    }
                });
            }
        };

        this.gridOptions.api.setDatasource(dataSource);

        //this.setGridData();
        setTimeout(() => {
            if (this.gridOptions) {
                this.gridOptions.api.sizeColumnsToFit();
            }
        }, 200);
    }

    setGridData() {
        if (this.gridOptions && this.props && this.props.dataList) {
            this.gridOptions.api.setRowData(this.props.dataList);
        }

        /*setTimeout(() => {
         if (this.gridOptions) {
         this.gridOptions.api.sizeColumnsToFit();
         }
         }, 200);*/
    }

    columnsDefinitions() {
        let columnDefs = [
            {
                headerName: "Date",
                field: "Date",
                headerTooltip: "Date",
                width: 60,
                filterParams: {applyButton: true, clearButton: true},
                cellStyle: {paddingTop: 0, textAlign: "left"}
            },
            {
                headerName: "FromJID",
                field: "FromJID",
                headerTooltip: "FromJID",
                filterParams: {applyButton: true, clearButton: true},
                cellStyle: {paddingTop: 0, textAlign: "left"}
            },
            {
                headerName: 'ToJID',
                headerTooltip: "ToJID",
                field: "ToJID",
                filterParams: {applyButton: true, clearButton: true},
                cellStyle: {paddingTop: 0, textAlign: "left"}
            },
            {
                headerName: 'Body',
                headerTooltip: "Body",
                field: "Body",
                filterParams: {applyButton: true, clearButton: true},
                cellStyle: {paddingTop: 0, textAlign: "left"}
            },
        ];
        return columnDefs;
    }

    onRowSelected() {
        var selectedRow = this.gridOptions.api.getSelectedRows()[0];

        /*if (selectedRow) {
         browserHistory.push(`/member/${selectedRow.Id}`);
         }*/
    }

    render() {
        console.log('render templates list');
        const {selectedChat} = this.props;
        this.selectedChat = selectedChat;
        this.setGridData();
        return (
            <div ref="mainComponent" className="ag-material" style={{width: "100%", margin: "auto", height: this.state.tableHeight + "px"}}>
                <AgGridReact
                    colWidth={120}
                    minColWidth={50}
                    onGridReady={this.onGridReady.bind(this)}
                    columnDefs={this.columnsDefinitions()}
                    onSelectionChanged={this.onRowSelected.bind(this)}
                    rowSelection="single"
                    rowModelType="infinite"
                    pagination="true"
                    enableSorting="false"
                    enableFilter="true"
                    floatingFilter="true"
                    enableColResize="true"
                    enableServerSideSorting="true"
                    enableServerSideFilter="true"
                    paginationPageSize="100"
                    infiniteInitialRowCount="100"
                    maxPagesInCache="2"
                />
            </div>
        );
    }
}

ChatArchiveList.contextTypes = {
    router: React.PropTypes.any.isRequired
};

const mapStateToProps = state => ({...state.chatArchive});

const mapDispatchToProps = dispatch => ({
    onGet: () =>
        dispatch({type: 'REQUEST_CHAT', payload: service.ChatArchiveServices.getChatArchives()}),
    onUnload: () =>
        dispatch({type: 'CHATS_PAGE_UNLOADED'}),
    onLogout: () =>
        dispatch({type: 'LOGOUT', payload: authService.Auth.logout()}),
    onError: (error) =>
        dispatch({type: 'ON_ERROR', payload: error, hasError: true})
});

export default connect(mapStateToProps, mapDispatchToProps)(ChatArchiveList);